import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog } from "../framework/dialog";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { CheckBox } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/checkbox";

//UserFurtherEducationListSearchDialog
//***************************************************************
export interface IUserFurtherEducationListSearchDialogProp {
    archived: boolean;
    classes?: string;
    onOk: (archived: boolean) => void;
    onCancel: () => void;
}

export interface IUserFurtherEducationListSearchDialogState {
    archived: boolean;
}

export class UserFurtherEducationListSearchDialog extends React.Component<IUserFurtherEducationListSearchDialogProp, IUserFurtherEducationListSearchDialogState> {
    constructor(props) {
        super(props);
        this.state = {
            archived: props.archived
        };
    }

    handleOkClick = () => {
        this.props.onOk(this.state.archived);
    };

    handleCancelClick = () => {
        this.props.onCancel();
    };

    handleClearClick = () => {
        this.setState({ archived: false });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const dialogClasses = "userFurtherEducationListSearchDialog" + (props.classes ? " " + props.classes : "");
        return (
            <Dialog
                classes={dialogClasses}
                title={Translations.SearchFurtherEducations}
                body={
                    <div>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group roWhite pt-2">
                                    <CheckBox
                                        title={Translations.ShowArchived}
                                        checked={state.archived}
                                        onClickBoolean={(checked: boolean) => {
                                            this.setState({ archived: checked });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }
                buttons={[
                    { title: Translations.Clear, buttonType: DialogButtonType.Default, classes: "mr-auto", onClick: this.handleClearClick },
                    { title: Translations.OK, buttonType: DialogButtonType.Primary, onClick: this.handleOkClick },
                    { title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: this.handleCancelClick }
                ]}
                onClose={this.handleCancelClick}/>
        );
    }
}